

import React from "react";
// import { Chrono } from "react-chrono";

const MomentsSec = () => {
    return (
        <div className="container-progressBar">
            <br />
            <br />
            <ul className="list-unstyled multi-steps">
                <li>Register</li>
                <li>Find Your Match</li>
                <li>Send Interest</li>
                <li className="is-active"> Start Meetup</li>
                <li> Getting Marriage</li>
            </ul>
        </div>
    )
};

export default MomentsSec;
